import React from "react";
import Select from '@material-ui/core/Select';
import makeStyles from '@material-ui/core/styles/makeStyles'
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles({
  selectBoxStyle: props => ({
    paddingLeft:20,
    width: props.mainWidth ? props.mainWidth : 120,
    paddingRight: "0px important",
    background: props.background ? props.background : "white",
    "& span": {
      '&::before': {
        content: props => props.placeholder ? `"${props.placeholder}"` : '',
        color: "rgba(51, 51, 51, 0.5)",
        fontSize: 14,
      }
    },
    "&:focus": {
      background: props.background ? props.background : "white",
    }
  }),
  paperlist: {
    padding: 0,
    maxHeight: 350,
    overflowY: "auto"
  },
  selectOptionList: {
    padding: "10px 12px",
    cursor: "pointer",
    "&:hover": {
      color: "#26bbed"
    }
  },
  selectOptionPaper: props => ({
    boxShadow: "0px 0px 30px 2px rgba(0, 0, 0, 0.05) !important",
    border: "1px solid #eeeeee",
    background: "white",
    width: props.width ? props.width : 330,
    marginLeft: -8,
    padding: 0
  }),

  flexBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left"
  },
  iconStyle: {
    fill: "#333333"
  }
})


const SelectComponent = ({ value, options, customValues, index, setFieldValue, disabled }) => {
  const { placeholder, width, mainWidth, background, disableUnderline } = customValues;
  const classes = useStyles({ placeholder: placeholder, background: background, width: width, mainWidth: mainWidth });
  const [selectedValue, setSelectedValue] = React.useState(value);

  React.useEffect(() => {
    setSelectedValue(value)
  }, [value])

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
    if (typeof setFieldValue === "function") {
      setFieldValue(`fieldArray.${index}`, {
        fieldDetails: e.target.value
      });
    }
  }


  const renderField = (value, index) => {
    return <MenuItem key={index} value={value} className={classes.selectOptionList}>{value.label || value.display}</MenuItem>
  }

  return (
    <Select
      id="demo-simple-select-hycxp"
      value={selectedValue}
      onChange={handleChange}
      classes={{
        root: classes.selectBoxStyle,
        icon: classes.iconStyle
      }}

      disabled={disabled}
      disableUnderline={disableUnderline}
      MenuProps={{
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        getContentAnchorEl: null,
        classes: {
          list: classes.paperlist,
          paper: classes.selectOptionPaper,

        }
      }}>
      {
        options && options.map(renderField)
      }
    </Select>
  )
}

export default SelectComponent